import { render, staticRenderFns } from "./footerSubscription.vue?vue&type=template&id=dc7f4fb6"
import script from "./footerSubscription.vue?vue&type=script&setup=true&lang=js"
export * from "./footerSubscription.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports